// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FTO6","left":"styles_left__1Fbua"};